import { Controller } from "@hotwired/stimulus";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";
import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";
export default class default_1 extends Controller {
    connect() {
        const boatGallerySelector = "[data-boat-gallery-item]";
        const hasBoatGalleryItems = this.element.querySelector(boatGallerySelector);
        this.primeVideoPreviews();
        lightGallery(this.element, {
            plugins: [lgVideo],
            speed: 0,
            // Boat media uses a dedicated attribute so nested guest-photo galleries
            // are not pulled into this lightbox. Guest galleries keep Stimulus targets.
            selector: hasBoatGalleryItems
                ? boatGallerySelector
                : this.galleryItemTargets,
            autoplayFirstVideo: false,
            autoplayVideoOnSlide: false,
            // lightGallery defaults YouTube/Vimeo embeds to muted; boat videos should play with sound.
            youTubePlayerParams: {
                mute: 0,
            },
            vimeoPlayerParams: {
                muted: 0,
            },
        });
    }
    /**
     * When no custom thumbnail exists, nudge muted preview videos off frame 0
     * so browsers paint a visible first frame (same idea as Ahoy Days).
     */
    primeVideoPreviews() {
        this.element
            .querySelectorAll("[data-gallery-video-preview]")
            .forEach((video) => {
            const seekPreviewFrame = () => {
                if (video.currentTime >= 0.05) {
                    return;
                }
                try {
                    video.currentTime = 0.1;
                }
                catch (_a) {
                    // Some browsers block seeking before enough data is buffered.
                }
            };
            if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
                seekPreviewFrame();
                return;
            }
            video.addEventListener("loadeddata", seekPreviewFrame, { once: true });
        });
    }
}
default_1.targets = ["galleryItem"];
